import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { FC } from 'react';
import AppSpinner from '../../common/components/AppSpinner';

const SnackbarWrapper: FC<React.PropsWithChildren<SnackbarWrapperProps>> = ({
  children,
  closeFunction,
  isShowingSpinner,
  hideCloseIcon,
  id,
}) => {
  return (
    <Box
      display='flex'
      alignItems='center'
      justifyContent={hideCloseIcon ? 'flex-start' : 'space-between'}
      width='100%'>
      {isShowingSpinner && (
        <span style={hideCloseIcon ? { marginInlineEnd: '12px' } : {}}>
          <AppSpinner disablePositionAbsolute noText size={20} />
        </span>
      )}

      <span id={id}>{children}</span>

      {!hideCloseIcon && (
        <Button
          variant='text'
          color='inherit'
          aria-label='close'
          sx={{ marginInlineStart: 1 }}
          onClick={closeFunction}>
          dismiss
        </Button>
      )}
    </Box>
  );
};

interface SnackbarWrapperProps {
  closeFunction: () => void;
  isShowingSpinner?: boolean;
  hideCloseIcon?: boolean;
  id?: string;
}

export default SnackbarWrapper;
